<template>
<div id="app">
  <div id="info" class='fixed-top' style="background-color:#cc0033">
    <nav class="navbar px-3" toggleable="lg">
      <div class="navbar-brand" style="color:#ffffff"><h6 class="page-title-header">{{ pageTitle }}</h6></div>
      <div v-if="isLogin" class="ml-auto">
        <!--PC時に表示 -->
        <div class="card d-none d-lg-block" no-body style="border:1px solid; height:42px; width: 162px; background-color:#ffffff; text-align:left; padding: 8px 8px 16px 16px;">
            <div class="card-body" style="padding: 0 0 0 0;">
              <div style="height: 12px">
                <img class="daccount_logo" src="https://id.smt.docomo.ne.jp/img/logo_header.png"/>
              </div>
              <div style="height: 20px">
                <a data-toggle="tooltip" title="ログアウトする" v-on:click="logout" class="daccount_txt_pc" href="#" target="_self">{{daccount}}</a>
              </div>
            </div>
        </div>
        <!-- sp,tab時に表示 -->
        <div class="card d-lg-none" no-body style="border:1px solid; height: 26px; width: 235px; background-color:#ffffff; text-align:left; padding: 0px 0px 0px 0px;">
          <div class="card-body" style="padding: 0 0 0 0;">
            <img class="daccount_logo_sp" src="https://id.smt.docomo.ne.jp/img/logo_header.png"/>
            <a data-toggle="tooltip" title="ログアウトする" v-on:click="logout" class="daccount_txt_sp" href="#" target="_self">{{daccount}}</a>
          </div>
        </div>
        <form name="sendrequest" method="post">
            <input type="hidden" name="serviceurl" v-model="requestData.serviceurl">
            <input type="hidden" name="linkname" v-model="requestData.linkname">
            <input type="hidden" name="message" v-model="requestData.message">
            <input type="hidden" name="dispflg" v-model="requestData.dispflg">
        </form>
      </div>
    </nav>
  </div>
  <div class="header-spacer" :style="{ height: headerHeight + 'px' }"></div>
  <div v-if="isLogin">
    <br>
  </div>
  <router-view/>
  <br>
  <footer class="site-footer" align="center">
    <router-link v-if="$route.path !== '/accessibility'" class="accessibility-link" to="/accessibility" target="_blank" rel="noopener noreferrer">本サイトのアクセシビリティの取組みについて</router-link>
    <p class="copyrights">© NTT DOCOMO</p>
  </footer>
</div>
</template>

<script>
export default {
  data() {
      return({
          logoutUrl: process.env.VUE_APP_LOGOUT_URL,
          requestData: {},
          headerHeight: 65
      })
  },
  created: function() {
      this.set_requestdata()
  },
  mounted: function() {
    this.updateHeaderHeight()
    window.addEventListener('resize', this.updateHeaderHeight)
  },
  updated: function() {
    this.updateHeaderHeight()
  },
  beforeUnmount: function() {
    window.removeEventListener('resize', this.updateHeaderHeight)
  },
  computed: {
    pageTitle () {
      if (this.$route.path === '/accessibility') {
        return '身に覚えのないご利用のお問い合わせのアクセシビリティの取組みについて'
      }
      return '身に覚えのないご利用のお問い合わせ画面'
    },
    isLogin () {
      return this.$store.getters.state
    },
    daccount (){
      return this.$store.getters.maskDocomoId;
    },
  },
  methods:{
    set_requestdata: function() {
        // リクエストデータ作成
        this.requestData.serviceurl = process.env.VUE_APP_REDIRECT_BASEURL
        // 仮設定
        this.requestData.linkname = "サービスへ戻る"
        this.requestData.message = "ログアウトしました。ご利用ありがとうございました。"
        this.requestData.dispflg = "1"
    },
    logout: function() {
      if(confirm("ログアウトしてもよろしいですか。") === false){
        return
      }
      // API呼び出し（同期）
      this.$api.post('/logout', {})
      .finally( () => {
        this.$store.dispatch("resetVariable")
        document.sendrequest.action=this.logoutUrl
        document.sendrequest.submit()
      })
    },
    header_height: function() {
      let target = document.getElementById("info");
      return target.offsetHeight
    },
    updateHeaderHeight: function() {
      this.$nextTick(() => {
        const height = this.header_height()
        if (height !== this.headerHeight) {
          this.headerHeight = height
        }
      })
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  text-align: center;
  color: rgb(29, 28, 29);
}
#info {
  font-size: 80%;
  background: white;
  padding: 10px 15px 0px 15px;
}

.page-title-header {
  white-space: normal;
  overflow-wrap: anywhere;
}

a:hover {
    color: #0056b3;
    text-decoration: underline;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

nav a.router-link-exact-active {
  color: #42b983;
}
hr{
  margin: 0px 20px 0px 20px;
}
body{
  padding: 0;
  text-align: center;
}

.titleForm{
  margin:10px 0px 50px;
  text-align: center;
}
.labelForm{
  margin:10px 0px 0px 0px;
}
.errorMsg{
  color:red;
  text-align: center;
  padding: 10px;
}
.errorMsg .left{
  text-align: left;
  display: inline-block;
}
.margintop{
  margin-top: 10px;
}

header{
  color: white;
  background: rgb(204, 0, 51);
}

.copyrights{
  margin: 0;
  color: white;
}
.site-footer{
  padding-top: 8px;
  background: rgb(204, 0, 51);
}
.accessibility-link{
  display: inline-block;
  margin-bottom: 8px;
  color: white;
  font-size: 13px;
}
.daccount_logo{
  height: 12px;
  width: 53px;
  vertical-align: top;
}
.daccount_logo_sp{
  height: 22px;
  width: 74px;
  padding: 3px 10px 1px 5px;
  border-right:1px solid;
  vertical-align: bottom;
}
.daccount_txt_pc{
  font-size:12px;
  vertical-align: bottom;
}
.daccount_txt_sp{
  font-size:12px;
  padding:5px 0px 1px 10px;
  vertical-align: bottom;
}
.padding12-top-bottom{
    padding-top: 12px;
    padding-bottom: 12px;
}
/* Button Style */
button.btn-u2m{
    --bs-btn-color: #fff;
    --bs-btn-bg: #17a2b8;
    --bs-btn-border-color: #17a2b8;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #138496;
    --bs-btn-hover-border-color: #138496;
    --bs-btn-focus-shadow-rgb: 49, 132, 253;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #17a2b8;
    --bs-btn-active-border-color: #17a2b8;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #17a2b8;
    --bs-btn-disabled-border-color: #17a2b8;
}

.input-group-append{
  width: 100%
}

/* Comment Style */
.comment p{
    padding-bottom: 0;
    margin-bottom: 0;
}
.comment ol, .comment ul{
    padding-bottom: 0;
    margin-bottom: 0;
}
.comment em {
  /* chromeでItalicを実現するためにBootStrapのデフォルトフォントを使用 */
  font-family: var(--bs-body-font-family);
}

</style>
